import { z } from 'zod';

/** 勤怠計算体系・勤怠計算 unit 一覧の URL 検索（scheduled タブ付き）。 */
export const AttendanceStructureUnitListSearchSchema = z.object({
  lifecycleTab: z.enum(['all', 'draft', 'applied', 'archived', 'scheduled']).default('applied'),
  countryCode: z.string().default('all'),
  /** 名称・説明に対するフリーテキスト絞り込み。 */
  freeText: z.string().catch(''),
  /** 利用勤怠計算項目の管理タグ絞り込み（いずれかのタグを含む unit に一致）。 */
  managementTags: z.array(z.string()).catch([]),
  pageSize: z.number().default(50),
  pageIndex: z.number().default(0)
});
export type AttendanceStructureUnitListSearchParams = z.infer<typeof AttendanceStructureUnitListSearchSchema>;